import axios, { AxiosInstance } from "axios";
import { authTokenStorage } from "@/auth/AuthTokenStorage";

export interface PaymentReportItem {
  id: number;
  type: string;
  referenceNumber?: string;
  amount: number;
  fee?: number;
  net?: number;
  available_on?: string;
  stripe_created?: string;
  mrID: number;
  taskID: number;
  jobNumber: string;
  taskNumber: string;
  approved: number;
  voided: number;
  customerID: number;
  addressID: number;
  techID: number;
  address_data: string;
  customer_name: string;
  tech_name: string;
  jobID: number;
  created_at: string;
  updated_at: string;
}

export interface PaymentReportResponse {
  success: boolean;
  results: PaymentReportItem[];
}

export class PaymentReportService {
  private request: AxiosInstance;

  constructor() {
    this.request = axios.create({
      baseURL: "https://payments.api.kbmercury.com",
    });

    // Add authentication interceptor
    this.request.interceptors.request.use(
      async (config) => {
        const token = await authTokenStorage.getAccessToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  async getReportData(
    start: string,
    end: string,
    type: "Etransfer" | "Stripe" | "Cheque"
  ): Promise<PaymentReportItem[]> {
    try {
      const response = await this.request.get<PaymentReportResponse>(
        "/report-data",
        {
          params: {
            start,
            end,
            type,
          },
        }
      );

      if (response.data.success && response.data.results) {
        return response.data.results;
      }
      return [];
    } catch (error) {
      console.error(`Error fetching ${type} report data:`, error);
      throw error;
    }
  }
}

export const paymentReportService = new PaymentReportService();

